import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=72d25cbf&scoped=true&"
import script from "./Resumen.vue?vue&type=script&lang=ts&"
export * from "./Resumen.vue?vue&type=script&lang=ts&"
import style0 from "./Resumen.vue?vue&type=style&index=0&id=72d25cbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d25cbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
